<template>
<div class="customer-avatar-upload-overlay" @click="closeAvatarUpload">
  <div v-if="isProcessing" class="customer-avatar-upload-spinner"></div>
</div>
<div  v-if="!isProcessing" class="customer-avatar-upload-buttons-container">
  <button @click="onPickCamera" class="customer-avatar-upload-button-container">
    <span class="customer-avatar-upload-caption">Camera</span>
    <input
      type="file"
      style="display: none"
      ref="cameraInput"
      name="picture"
      capture="environment"
      accept="image/*"
      @change="onPictureTaken"/>
  </button>
  <button @click="onPickFile" class="customer-avatar-upload-button-container">
    <span class="customer-avatar-upload-caption">Library</span>
    <input
      type="file"
      style="display: none"
      ref="fileInput"
      accept="image/png,image/jpeg"
      @change="onFilePicked"/>
  </button>
  <button v-if="customerAvatar" @click="removeAvatar" class="customer-avatar-upload-button-container customer-avatar-upload-remove-button-container">
    <span class="customer-avatar-upload-caption">Remove image</span>
  </button>
</div>
</template>

<script>
import api from '@/api';

export default {
  props: {
    customerId: {
      type: Number
    },
    customerAvatar: {
      type: String
    }
  },
  name: 'CustomerAvatarUpload',
  components: {
  },
  methods: {
    closeAvatarUpload() {
      if (!this.isProcessing) {
        this.$emit('showAvatarUpload', false)
      }
    },
    onPickCamera () {
      this.$refs.cameraInput.click()
    },
    onPickFile () {
      this.$refs.fileInput.click()
    },
    onPictureTaken (event) {
      this.isProcessing = true;
      const files = event.target.files
      this.avatar = files[0]
      let params = { avatar: this.avatar }
      api.updateCustomer(this.customerId, params).then(customer => {
        this.isProcessing = false;
        this.$emit('updateAvatar', customer)
      }).catch(errors => {
        this.isProcessing = false;
        console.error(errors);
      })
    },
    onFilePicked (event) {
      this.isProcessing = true;
      const files = event.target.files
      this.avatar = files[0]
      let params = { avatar: this.avatar }
      api.updateCustomer(this.customerId, params).then(customer => {
        this.isProcessing = false;
        this.$emit('updateAvatar', customer)
      }).catch(errors => {
        this.isProcessing = false;
        console.error(errors);
      })
    },
    removeAvatar() {
      this.isProcessing = true;
      let params = { remove_avatar: true }
      api.updateCustomer(this.customerId, params).then(customer => {
        this.isProcessing = false;
        this.$emit('updateAvatar', customer)
      }).catch(errors => {
        this.isProcessing = false;
        console.error(errors);
      })
    }
  },
  data() {
    return {
      isProcessing: false,
    }
  },
  emits: ["showAvatarUpload", "updateAvatar"],
}
</script>
<style scoped>
  .customer-avatar-upload-overlay {
    height: 100vh;
    width: 100vw;
    background-color: #181818;
    opacity: 0.75;
    position: fixed;
    z-index: 900;
    top: 0;
    left: 0
  }

  .customer-avatar-upload-spinner {
    background: url(../assets/images/loading_spinner.gif) no-repeat center center;
    width: 400px;
    height: 400px;
    margin: auto;
    height: 80vh;
  }
  .customer-avatar-upload-buttons-container {
    position: fixed;
    bottom: 0;
    width: 100vw;
    height: 133px;
    z-index: 901;
    background: white;
    display: flex;
    flex-direction: column;
  }
  .customer-avatar-upload-button-container {
    width: 100vw;
    height: 50%;
    display: flex;
    justify-content: flex-start;
    padding-left: 60px;
    align-items: center;
    border: none;
    color: black;
  }
  .customer-avatar-upload-button-container:first-child {
    border-bottom: 1px solid #E5E5E5;
    background: #ffffff url(../assets/images/camera.svg) no-repeat 25px center;
  }

  .customer-avatar-upload-caption {
    font-size: 17px;
  }

  .customer-avatar-upload-button-container:nth-child(2) {
    background: #ffffff url(../assets/images/library.svg) no-repeat 25px center;
  }

  .customer-avatar-upload-remove-button-container:last-child {
    background-color: #D43F21;
    justify-content: center;
    padding-left: 0;
    color: white;
  }
</style>
